import { keyframes } from "@emotion/react";

import { FIELDWORKER_COLORS } from "~/config/statusColors";

const loadingAnimation = keyframes`
  0%, 100% {
    background-color: ${FIELDWORKER_COLORS.available};
  }
  50% {
    background-color: ${FIELDWORKER_COLORS.assigned};
  }
`;

export const fieldworkerLoadingAnimation = `${loadingAnimation} 1.5s ease-in-out infinite`;
